import { render, staticRenderFns } from "./dataTabel.vue?vue&type=template&id=a9363250&scoped=true"
import script from "./dataTabel.vue?vue&type=script&lang=js"
export * from "./dataTabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9363250",
  null
  
)

export default component.exports